import * as React from "react"
import { RouteComponentProps } from "react-router"

import { ChangePasswordRequestForm } from "../ChangePasswordRequestForm"
import { ApplicationPath } from "features/Navigation"
import { ContentWithSpeakupLogo } from "features/Shared/components/ContentWithSpeakupLogo"
import { OperationContext } from "features/Backend"

import * as Styles from "./ChangePasswordRequestPage.styles"

import {
  useRequestPasswordResetMutation,
} from "graphql/mutations/generated/PasswordReset"

export const ChangePasswordRequestPage = (props: RouteComponentProps) => {
  const [ getPasswordReset ] = useRequestPasswordResetMutation()

  return (
    <ContentWithSpeakupLogo>
      <Styles.CardWrapper>
        <ChangePasswordRequestForm onSubmit={sendReinitializationMail} onGoBack={goBack} onGoLogin={goLogin} />
      </Styles.CardWrapper>
    </ContentWithSpeakupLogo>
  )

  async function sendReinitializationMail(email: string) {
    await getPasswordReset({
      context: { shouldUseAuthSchema: true } as OperationContext,
      variables: {
        email,
      },
    })
  }

  function goLogin() {
    props.history.push(ApplicationPath.Login)
  }

  function goBack() {
    props.history.goBack()
  }
}
